// Corrected initial state for required fields
MultiStepForm[4] = {
  occupation: false,
  neto_income: false,
  monthly_expenses: false, // Corrected: Was true, should be false initially
  remuneration_deadline: false,
  car_owner: false,
  // employment_start_date: false, // Handled conditionally
  // car_plate_number: false, // Handled conditionally
  // job_area is NOT required based on HTML, so not included here
};

let dates = {
  remuneration_deadline: "",
  employment_start_date: "",
};

// Use moment.js if available, otherwise basic comparison
const isDateInFuture = (dateStr) => {
    // Assumes dateStr is DD-MM-YYYY
    const parts = dateStr.split('-');
    if (parts.length !== 3) return false;
    const date = new Date(parts[2], parts[1] - 1, parts[0]); // year, month (0-indexed), day
    if (isNaN(date.getTime())) return false; // Invalid date
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time part for accurate date comparison
    return date >= today;
};

const isDateInPastOrToday = (dateStr) => {
    // Assumes dateStr is DD-MM-YYYY
    const parts = dateStr.split('-');
    if (parts.length !== 3) return false;
    const date = new Date(parts[2], parts[1] - 1, parts[0]); // year, month (0-indexed), day
     if (isNaN(date.getTime())) return false; // Invalid date
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time part
    return date <= today;
};


const regex_numeric = /^[0-9]+$/i; // Allow only digits, ensure non-empty later
// const regex_car_plate_number = /^\d{4}\s*[BCDFGHJKLMNPRSTVWXYZ]{3}|[A-Z]{2,3}\s*\d{4}\s*[A-Z]{2}$/  old regex
// Updated regex for Spanish plates (NNNN LLL format) - case-insensitive for letters
const regex_car_plate_number = /^[0-9]{4}\s?[BCDFGHJKLMNPRSTVWXYZ]{3}$/i;

const validateIncome = (value) => {
    const trimmedValue = value.trim();
    // Check if it's not empty and contains only numbers
    return trimmedValue !== '' && regex_numeric.test(trimmedValue);
};

const validateCarPlateNumber = (value) => {
    const trimmedValue = value.trim();
    return trimmedValue !== '' && regex_car_plate_number.test(trimmedValue);
};

const validateRemunerationDeadline = () => {
  const day = document.getElementById("remuneration_deadline-day").value;
  const month = document.getElementById("remuneration_deadline-month").value;
  const year = document.getElementById("remuneration_deadline-year").value;

  if (!day || !month || !year) return false; // Ensure all parts selected

  const value = day + "-" + month + "-" + year;
  if (value.length == 10) {
    dates.remuneration_deadline = value;
    // Validate that the date is today or in the future
    return isDateInFuture(value);
  }
  return false;
};

const validateEmploymentStartDate = () => {
  const day = document.getElementById("employment_start_date-day").value;
  const month = document.getElementById("employment_start_date-month").value;
  const year = document.getElementById("employment_start_date-year").value;

  if (!day || !month || !year) return false; // Ensure all parts selected

  const value = day + "-" + month + "-" + year;
  if (value.length == 10) {
    dates.employment_start_date = value;
     // Validate that the date is today or in the past
    return isDateInPastOrToday(value);
  }
  return false;
};

jQuery(document).ready(function ($) {

    // --- Input Field Validation (Income, Expenses, Car Plate) ---
    $("body").on("keyup", "#form-input-step-4 input", function () {
        const value = $(this).val();
        const name = $(this).data("name");
        const field = $(this).data("label").replace(/-/g, " ").toLowerCase();
        let success = false;
        let messageOverride = "";

        if (["neto_income", "monthly_expenses"].includes(name)) {
            // Allow only numbers
            var inputElement = $(this);
            var cleanedValue = inputElement.val().replace(/[^\d]/g, '');
            // Limit to 10000 (Optional based on previous logic)
            // cleanedValue = Math.min(cleanedValue, 10000);
            if (inputElement.val() !== cleanedValue) {
                inputElement.val(cleanedValue); // Update input only if changed
            }
             success = validateIncome(cleanedValue); // Validate the cleaned value
             if (!success && cleanedValue !== '') {
                 messageOverride = `Por favor, ingresa un ${field} válido (solo números).`;
             } else if (!success && cleanedValue === '') {
                 messageOverride = `Por favor, ingresa tu ${field}.`;
             }
        } else if (name === "car_plate_number") {
            // Only validate if the field is visible (car owner = YES)
             if ($(".field-LeadForm-car_plate_number").is(":visible")) {
                success = validateCarPlateNumber(value);
                 if (!success && value.trim() !== '') {
                     messageOverride = "Por favor, ingresa un número de matrícula válido (e.g., 1234 ABC).";
                 } else if (!success && value.trim() === '') {
                     messageOverride = "Por favor, ingresa tu número de matrícula.";
                 }
            } else {
                success = true; // Not required if hidden
            }
        } else if (name === "job_area") {
             // job_area is not required, so always mark as success for validation purposes
             success = true;
             // Optional: Add specific validation if needed, but don't block submission
        }


        if (success) {
            // For car_plate_number, only mark success if it's actually required and valid
            if (name === 'car_plate_number' && !$(".field-LeadForm-car_plate_number").is(":visible")) {
                 // If hidden, don't add success class, it's implicitly valid
                 MultiStepForm[4][name] = true; // Update state if needed
            } else if (name !== 'job_area') { // Don't track job_area state for blocking
                 showSuccess(4, name);
            }
        } else if (name !== 'job_area') { // Don't show errors for optional job_area
            showError(4, name, field, value, messageOverride);
        }
    });

    // --- Date Field Validation ---
    $("body").on("change", "#form-date-step-4 select", function (event) {
        const name = $(this).data("name"); // e.g., remuneration_deadline or employment_start_date
        let success = false;
        let fieldLabel = "";
        let messageOverride = "";

        if (name === "remuneration_deadline") {
            success = validateRemunerationDeadline();
            fieldLabel = "fecha límite del próximo sueldo";
            if (!success && dates[name]) { // If validation failed after selecting parts
                 messageOverride = "La fecha límite del próximo sueldo debe ser hoy o una fecha futura.";
            }
        } else if (name === "employment_start_date") {
             // Only validate if the field is visible/required
             if ($(".field-LeadForm-employment_start_date").is(":visible")) {
                success = validateEmploymentStartDate();
                fieldLabel = "empleo fecha de inicio";
                 if (!success && dates[name]) { // If validation failed after selecting parts
                     messageOverride = "La fecha de inicio del empleo debe ser hoy o una fecha pasada.";
                 }
            } else {
                success = true; // Not required if hidden
            }
        }

        if (success) {
             // For employment_start_date, only mark success if it's required and valid
             if (name === 'employment_start_date' && !$(".field-LeadForm-employment_start_date").is(":visible")) {
                  // If hidden, don't add success class, it's implicitly valid
                  // Ensure it's removed from the required check if it exists
                  if (MultiStepForm[4].hasOwnProperty(name)) {
                     MultiStepForm[4][name] = true; // Mark as valid since not required
                  }
             } else {
                $(`#LeadForm-${name}`).val(dates[name]); // Update hidden input
                showSuccess(4, name);
             }
        } else {
             // Clear hidden input if date is invalid
             $(`#LeadForm-${name}`).val("");
             if (messageOverride === "" && (!document.getElementById(`${name}-day`).value || !document.getElementById(`${name}-month`).value || !document.getElementById(`${name}-year`).value)) {
                  messageOverride = `Por favor, selecciona la ${fieldLabel} completa.`; // Message for incomplete selection
             } else if (messageOverride === "") {
                 messageOverride = `Por favor, selecciona una ${fieldLabel} válida.`; // Generic message if specific one not set
             }
             showError(4, name, fieldLabel, "", messageOverride);
        }
    });

    // --- Radio Button Validation (Occupation, Car Owner) ---
    $("body").on("change", '#form-step-4 input[type="radio"]', function () {
        const name = $(this).attr("name"); // Get name attribute (e.g., LeadForm[occupation])
        const fieldName = $(this).data("name"); // Get data-name (e.g., occupation)
        const value = $(this).val();
        let fieldLabel = "";

        if (fieldName === "occupation") {
            fieldLabel = "Situación laboral";
            const requiresStartDate = value === "EMPLOYED_INDEFINITE_PERIOD";
            // const requiresJobArea = ["EMPLOYED_INDEFINITE_PERIOD", "ECONOMIC_ACTIVITY", "MATERNITY_LEAVE", "PENSIONER1"].includes(value); // Based on original logic

            // Handle employment_start_date visibility and requirement
            if (requiresStartDate) {
                $(".field-LeadForm-employment_start_date").show();
                if(MultiStepForm[4].employment_start_date != ''){
                    MultiStepForm[4].employment_start_date = validateEmploymentStartDate(); // Re-validate if already filled
                    // Trigger validation display for the date field
                    //$("#form-date-step-4 select[data-name='employment_start_date']").trigger('change');
                }
            } else {
                $(".field-LeadForm-employment_start_date").hide();
                // Clear values and errors, mark as valid since not required
                $("#employment_start_date-day, #employment_start_date-month, #employment_start_date-year").val("");
                $("#LeadForm-employment_start_date").val("");
                $(".field-LeadForm-employment_start_date").removeClass("has-error has-success");
                $("#error_employment_start_date").html("").addClass("d-none");
                // Remove from required check or mark as true
                if (MultiStepForm[4].hasOwnProperty('employment_start_date')) {
                     MultiStepForm[4].employment_start_date = true;
                }
            }

             // Handle job_area visibility (Assuming it's not required for submission)
             // if (requiresJobArea) {
             //     $(".field-LeadForm-job_area").show();
             // } else {
             //     $(".field-LeadForm-job_area").hide();
             //     $("#LeadForm-job_area").val(""); // Clear value if hidden
             // }

             // Update occupation status
             showSuccess(4, fieldName);

        } else if (fieldName === "car_owner") {
            fieldLabel = "¿Tienes un vehículo en propiedad?";
            const requiresPlateNumber = value === "YES";

            if (requiresPlateNumber) {
                $(".field-LeadForm-car_plate_number").show();
                // Add to required check and validate
                MultiStepForm[4].car_plate_number = validateCarPlateNumber($("#LeadForm-car_plate_number").val());
                 // Trigger validation display for the plate number field
                 $("#LeadForm-car_plate_number").trigger('keyup');
            } else {
                $(".field-LeadForm-car_plate_number").hide();
                // Clear value and errors, mark as valid since not required
                $("#LeadForm-car_plate_number").val("");
                $(".field-LeadForm-car_plate_number").removeClass("has-error has-success");
                $("#error_car_plate_number").html("").addClass("d-none");
                // Remove from required check or mark as true
                 if (MultiStepForm[4].hasOwnProperty('car_plate_number')) {
                     MultiStepForm[4].car_plate_number = true;
                 }
            }
             // Update car_owner status
             showSuccess(4, fieldName);
        }

        // General check for radio selection (redundant if handled above, but safe)
        if ($(`input[name="${name}"]:checked`).length > 0) {
            showSuccess(4, fieldName);
        } else {
            // This case is unlikely for radios but included for safety
            showError(4, fieldName, fieldLabel, '', `Por favor, selecciona una opción para ${fieldLabel}.`);
        }
    });


    // --- Button Handlers ---
    $("body").on("click", "#submit-button-step-4", function (event) {
        event.preventDefault();
        submitForm(4);
    });

    $("body").on("click", "#previous-button-step-4", function (event) {
        event.preventDefault();
        showPreviousForm(3);
    });

    $("body").on("click", "#mobile-previous-button-step-4", function (event) {
        event.preventDefault();
        showPreviousForm(3);
    });

    $("body").on("click", "#sidebar-step-3", function (event) {
        event.preventDefault();
        showPreviousForm(3, "sidebar");
    });
});
